
riot.tag2('modals', '\n  <div class="modal-backdrop fade {&quot;in&quot;: backdrop, &quot;hidden&quot;: !backdrop}"></div>\n', '', '', function(opts) {
'use strict';

var self = this,
    modals = [],
    count = 0;

self.backdrop = false;
//self.backdropHidden = true

self.create = function (name, opts) {
    var elem = document.createElement('div');
    self.root.appendChild(elem);

    var modal = riot.mount(elem, name, opts)[0];

    if (modal) {
        if (modals.length > 0) {
            modals[modals.length - 1].modalHide();
        } else {
            self.backdrop = true;
            self.update();
        }

        modal.modalUID = ++count;
        modals.push(modal);

        modal.on('shown', function () {
            document.body.classList.add('modal-open');
        });

        modal.on('hidden', function () {
            if (this.modalUID == count && modals.length > 0) {
                var m = modals.pop();
                m.unmount();
                --count;
                if (modals.length > 0) {
                    modals[modals.length - 1].modalShow();
                } else {
                    document.body.classList.remove('modal-open');
                    self.backdrop = false;
                    self.update();
                }
            }
        });

        modal.modalShow();
        return modal;
    }
};
});
riot.tag2('bs-modal', '  <div class="modal" onclick="{!cannotBeClosed ? close : &quot;close&quot;}" tabindex="-1" riot-style="{&quot;display: block;&quot;: animationEnd, &quot;display: none;&quot;: !animationEnd};">\n    <div class="modal-dialog {modalVisible ? animation.show : animation.hide} {parent.opts.size}">\n      <div class="modal-content">\n        <div class="modal-header {parent.opts.type}">\n          <button class="close" onclick="{!cannotBeClosed ? modalHide : &quot;modalHide&quot;}" type="button"><span>&times;</span></button>\n          <yield from="title"></yield>\n        </div>\n        <div class="modal-body">\n          <yield from="body"></yield>\n        </div>\n        <div class="modal-footer">\n          <yield from="footer"></yield>\n        </div>\n      </div>\n    </div>\n  </div>\n', 'bs-modal .modal-dialog,[riot-tag="bs-modal"] .modal-dialog,[data-is="bs-modal"] .modal-dialog{ -webkit-animation-duration: .4s; animation-duration: .4s; } bs-modal .modal-default,[riot-tag="bs-modal"] .modal-default,[data-is="bs-modal"] .modal-default,bs-modal .modal-primary,[riot-tag="bs-modal"] .modal-primary,[data-is="bs-modal"] .modal-primary,bs-modal .modal-success,[riot-tag="bs-modal"] .modal-success,[data-is="bs-modal"] .modal-success,bs-modal .modal-info,[riot-tag="bs-modal"] .modal-info,[data-is="bs-modal"] .modal-info,bs-modal .modal-warning,[riot-tag="bs-modal"] .modal-warning,[data-is="bs-modal"] .modal-warning,bs-modal .modal-danger,[riot-tag="bs-modal"] .modal-danger,[data-is="bs-modal"] .modal-danger{ border-radius: 4px 4px 0 0; } bs-modal .modal-default,[riot-tag="bs-modal"] .modal-default,[data-is="bs-modal"] .modal-default{ background-color: #FFFFFF; color: #333; } bs-modal .modal-primary,[riot-tag="bs-modal"] .modal-primary,[data-is="bs-modal"] .modal-primary{ background-color: #337AB5; color: #fff; } bs-modal .modal-success,[riot-tag="bs-modal"] .modal-success,[data-is="bs-modal"] .modal-success{ background-color: #5CB85C; color: #fff; } bs-modal .modal-info,[riot-tag="bs-modal"] .modal-info,[data-is="bs-modal"] .modal-info{ background-color: #5BC0DE; color: #fff; } bs-modal .modal-warning,[riot-tag="bs-modal"] .modal-warning,[data-is="bs-modal"] .modal-warning{ background-color: #F0AD4E; color: #fff; } bs-modal .modal-danger,[riot-tag="bs-modal"] .modal-danger,[data-is="bs-modal"] .modal-danger{ background-color: #D9534F; color: #fff; }', '', function(opts) {
'use strict';

var self = this;

self.cannotBeClosed = false;
self.modalVisible = false;
self.animationEnd = false;
self.items = [];

self.animation = {
    show: 'animated fadeInDown',
    hide: 'animated fadeOutUp'
};

if (self.parent.opts.animation) {
    self.animation = {
        show: self.parent.opts.animation.show || 'animated fadeInDown',
        hide: self.parent.opts.animation.hide || 'animated fadeOutUp'
    };
}

//self.stopPropagation = function (e) {
//    e.stopPropagation()
//}

self.close = function (e) {
    if (e.target == self.root.children[0]) self.modalHide();
    return true;
};

self.modalHide = function () {
    self.modalVisible = false;
    self.parent.trigger('hide');
    var end = function end() {
        self.animationEnd = false;
        self.parent.trigger('hidden');
        this.removeEventListener('animationend', end);
        this.removeEventListener('webkitAnimationEnd', end);
        this.removeEventListener('oAnimationEnd', end);
    };
    self.root.addEventListener('animationend', end);
    self.root.addEventListener('webkitAnimationEnd', end);
    self.root.addEventListener('oAnimationEnd', end);
    //self.root.addEventListener('transitionend', end)
    self.update();
};

self.modalShow = function () {
    self.parent.trigger('show');
    self.modalVisible = true;
    self.animationEnd = true;
    var end = function end() {
        self.parent.trigger('shown');
        this.removeEventListener('animationend', end);
        this.removeEventListener('webkitAnimationEnd', end);
        this.removeEventListener('oAnimationEnd', end);
    };
    self.root.addEventListener('animationend', end);
    self.root.addEventListener('webkitAnimationEnd', end);
    self.root.addEventListener('oAnimationEnd', end);
    //self.root.addEventListener('transitionend', end)
    self.update();
};

if (self.parent) {
    self.parent.modalVisible = self.modalVisible;
    self.parent.modalHide = self.modalHide;
    self.parent.modalShow = self.modalShow;
}
});
riot.tag2('bs-alert', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title text-center">{parent.opts.title}</div>\n    </yield>\n    <yield to="body">\n      <div class="text-center">{parent.opts.text}</div>\n    </yield>\n    <yield to="footer">\n      <div class="text-center">\n        <button class="btn {style}" each="{parent.opts.buttons}" onclick="{parent.parent.click}" type="button">{title}</button>\n      </div>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

if (!opts.animation) {
    opts.animation = {
        show: 'animated zoomIn',
        hide: 'animated zoomOut'
    };
}

self.callback = opts.callback || function (action) {
    self.modalHide();
};

self.click = function (e) {
    self.callback(e.item.action);
};
});
riot.tag2('bs-prompt', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{parent.opts.title}</div>\n    </yield>\n    <yield to="body">\n      <div class="form-group">\n        <label class="control-label">{parent.opts.label}</label>\n        <input class="form-control" type="{parent.opts.inputType || &quot;text&quot;}" name="{parent.opts.inputName || &quot;name&quot;}" min="{parent.opts.min}" max="{parent.opts.max}" step="{parent.opts.step}">\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
});


// WEBPACK FOOTER //
// ./components/modals.tag